import content from './content.js';
import custom_profile_fields from './custom-profile-fields.js';
import sign_up_and_sign_in from './sign-up-and-sign-in.js';
const sign_in_exp = {
    page_title: 'Experiência de login',
    page_title_with_account: 'Login e conta',
    title: 'Login e conta',
    description: 'Personalize os fluxos de autenticação e a interface do usuário, e visualize a experiência pronta para uso em tempo real.',
    tabs: {
        branding: 'Marca',
        sign_up_and_sign_in: 'Inscreva-se e faça login',
        collect_user_profile: 'Coletar perfil do usuário',
        account_center: 'Centro de contas',
        content: 'Conteúdo',
        password_policy: 'Política de senhas',
    },
    welcome: {
        title: 'Personalize a experiência de login',
        description: 'Comece rapidamente com a configuração do seu primeiro login. Este guia o acompanhará em todas as configurações necessárias.',
        get_started: 'Começar',
        apply_remind: 'Observe que a experiência de login será aplicada a todos os aplicativos nesta conta.',
    },
    color: {
        title: 'COR',
        primary_color: 'Cor da marca',
        dark_primary_color: 'Cor da marca (Escuro)',
        dark_mode: 'Ativar modo escuro',
        dark_mode_description: 'Seu aplicativo terá um tema de modo escuro gerado automaticamente com base na cor da sua marca e no algoritmo Logto. Você é livre para personalizar.',
        dark_mode_reset_tip: 'Recalcule a cor do modo escuro com base na cor da marca.',
        reset: 'Recalcular',
    },
    branding: {
        title: 'ÁREA DE MARCA',
        ui_style: 'Estilo',
        with_light: '{{value}}',
        with_dark: '{{value}} (escuro)',
        app_logo_and_favicon: 'Logo do aplicativo e favicon',
        company_logo_and_favicon: 'Logo da empresa e favicon',
        organization_logo_and_favicon: 'Logo da organização e favicon',
        hide_logto_branding: 'Ocultar a marca Logto',
        hide_logto_branding_description: 'Remova "Powered by Logto". Destaque apenas a sua marca com uma experiência de login limpa e profissional.',
        hide_logto_branding_oss_note: 'Este recurso está disponível nativamente no <a>Logto Cloud</a>.',
    },
    branding_uploads: {
        app_logo: {
            title: 'Logo do aplicativo',
            url: 'URL do logo do aplicativo',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: 'Logo do aplicativo: {{error}}',
        },
        company_logo: {
            title: 'Logo da empresa',
            url: 'URL do logo da empresa',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: 'Logo da empresa: {{error}}',
        },
        organization_logo: {
            title: 'Upload de imagem',
            url: 'URL do logo da organização',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: 'Logo da organização: {{error}}',
        },
        connector_logo: {
            title: 'Upload de imagem',
            url: 'URL do logo do conector',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: 'Logo do conector: {{error}}',
        },
        favicon: {
            title: 'Favicon',
            url: 'URL do favicon',
            url_placeholder: 'https://your.cdn.domain/favicon.ico',
            error: 'Favicon: {{error}}',
        },
    },
    custom_ui: {
        title: 'UI personalizado',
        cloud_tag: 'Cloud',
        css_code_editor_title: 'CSS personalizado',
        css_code_editor_field_title: 'Substituição de CSS',
        css_code_editor_description1: 'Veja o exemplo de CSS personalizado.',
        css_code_editor_description2: '<a>{{link}}</a>',
        css_code_editor_description_link_content: 'Saiba mais',
        css_code_editor_content_placeholder: 'Insira aqui suas substituições de CSS para ajustar os estilos de qualquer elemento exatamente às suas necessidades. Expresse sua criatividade e faça sua UI se destacar.',
        bring_your_ui_title: 'Traga sua UI',
        bring_your_ui_upload_title: 'Enviar recursos de UI personalizados',
        bring_your_ui_description: 'Carregue um pacote compactado (.zip) para substituir a UI pré-construída do Logto pelo seu próprio código. <a>Saiba mais</a>',
        bring_your_ui_oss_description: 'Personalize a interface de login com o seu próprio código.',
        bring_your_ui_oss_card_description: 'Envie sua interface de login personalizada diretamente para o <a>Logto Cloud</a>. Não é preciso fazer fork nem implantar novamente.',
        bring_your_ui_oss_try_cloud: 'Experimentar Cloud',
        preview_with_bring_your_ui_description: 'Seus ativos de UI personalizados foram carregados com sucesso e agora estão sendo servidos. Consequentemente, a janela de visualização interna foi desativada.\nPara testar sua UI de login personalizada, clique no botão "Visualização em tempo real" para abri-la em uma nova aba do navegador.',
        csp_description: 'Permita expressões de origem adicionais para sua interface de login personalizada. Esses valores são aplicados somente quando os ativos de UI personalizados são servidos.',
        csp_script_src: 'script-src permitido',
        csp_script_src_tip: 'Permita expressões de origem HTTPS para scripts carregados pela sua UI personalizada, como https://scripts.example.com ou https://*.example.com.',
        csp_connect_src: 'connect-src permitido',
        csp_connect_src_tip: 'Permita expressões de origem HTTPS ou WSS para solicitações de rede feitas pela sua UI personalizada, como https://api.example.com ou wss://events.example.com.',
        csp_source_invalid_error: 'Insira uma expressão de origem válida. Use URLs https://; connect-src também aceita wss://. Palavras-chave CSP e ponto e vírgula não são aceitos.',
        csp_source_duplicate_error: 'Esta expressão de origem já está listada.',
    },
    account_center: {
        title: 'CENTRO DE CONTA',
        description: 'Personalize os fluxos do centro de conta com as APIs do Logto.',
        enable_account_api: 'Ativar o centro de conta e a Account API',
        enable_account_api_description: 'Ativa tanto a Account API voltada ao usuário final quanto o centro de contas pronto para uso da Logto. Quando desativado, ambos os recursos ficam indisponíveis.',
        field_options: {
            off: 'Desativado',
            edit: 'Editar',
            read_only: 'Somente leitura',
            enabled: 'Ativado',
            disabled: 'Desabilitado',
        },
        sections: {
            account_security: {
                title: 'SEGURANÇA DA CONTA',
                description: 'Gerencie o acesso à Account API, permitindo que os usuários vejam ou editem suas informações de identidade e fatores de autenticação depois de entrar no aplicativo.',
                security_verification: {
                    title: 'Verificação de segurança',
                    description: 'Antes de alterar as configurações de segurança, os usuários devem verificar sua identidade para obter um ID de registro de verificação válido por 10 minutos. Para habilitar um método de verificação (e-mail, telefone, senha), defina a permissão da Account API abaixo como <strong>Somente leitura</strong> (mínimo) ou <strong>Editar</strong> para que o sistema possa detectar se o usuário o configurou. <a>Saiba mais</a>',
                },
                groups: {
                    identifiers: {
                        title: 'Identificadores',
                    },
                    authentication_factors: {
                        title: 'Fatores de autenticação',
                    },
                    session_management: {
                        title: 'Gerenciamento de sessão',
                    },
                },
            },
            user_profile: {
                title: 'PERFIL DO USUÁRIO',
                description: 'Gerencie o acesso à Account API para que os usuários possam visualizar ou editar dados básicos ou personalizados de perfil depois de entrar no aplicativo.',
                groups: {
                    profile_data: {
                        title: 'Dados de perfil',
                    },
                },
            },
            secret_vault: {
                title: 'COFRE SECRETO',
                description: 'Para conectores sociais e empresariais, armazene com segurança tokens de acesso de terceiros para chamar suas APIs (por exemplo, adicionar eventos ao Google Agenda).',
                third_party_token_storage: {
                    title: 'Token de terceiros',
                    third_party_access_token_retrieval: 'Recuperação de token de acesso de terceiros',
                    third_party_token_tooltip: 'Para armazenar tokens, ative esta opção nas configurações do conector social ou empresarial correspondente.',
                    third_party_token_description: 'Depois que a Account API é ativada, a recuperação de tokens de terceiros também é ativada automaticamente.',
                },
            },
        },
        fields: {
            email: 'Endereço de e-mail',
            phone: 'Número de telefone',
            social: 'Identidades sociais',
            password: 'Senha',
            mfa: 'Autenticação multifator',
            mfa_description: 'Permita que os usuários gerenciem seus métodos de MFA a partir do centro de conta.',
            username: 'Nome de usuário',
            name: 'Nome',
            avatar: 'Avatar',
            profile: 'Perfil',
            profile_description: 'Controle o acesso aos atributos estruturados do perfil.',
            custom_data: 'Dados personalizados',
            custom_data_description: 'Controle o acesso aos dados JSON personalizados armazenados no usuário.',
            sessions: 'Sessões',
        },
        profile_fields: {
            title: 'Campos de perfil para o centro de conta pré-construído',
            add_profile_fields: 'Adicionar campos de perfil',
            hint: {
                not_in_list: 'Não está na lista?',
                set_up: 'Configurar',
                go_to: 'outros campos de perfil agora.',
            },
            disabled_hint: {
                name: 'Para adicionar este campo, defina primeiro a permissão "Nome" como "Editar/Somente leitura" em Dados do perfil acima.',
                avatar: 'Para adicionar este campo, defina primeiro a permissão "Avatar" como "Editar/Somente leitura" em Dados do perfil acima.',
                profile: 'Para adicionar este campo, defina primeiro a permissão "Perfil" como "Editar/Somente leitura" em Dados do perfil acima.',
                custom_data: 'Para adicionar este campo, defina primeiro a permissão "Dados personalizados" como "Editar/Somente leitura" em Dados do perfil acima.',
            },
        },
        webauthn_related_origins: 'Origens relacionadas ao WebAuthn',
        webauthn_related_origins_description: 'Adicione os domínios dos seus aplicativos front-end autorizados a registrar passkeys por meio da Account API.',
        webauthn_related_origins_error: 'A origem deve começar com https:// ou http://',
        delete_account_url: 'Excluir conta',
        delete_account_url_description: 'Forneça sua própria URL de endpoint para processar a exclusão de conta com lógica personalizada.',
        prebuilt_ui: {
            title: 'INTEGRAR UI PRÉ-CONSTRUÍDO',
            description: 'Integre rapidamente o centro de contas pronto para uso, a verificação de segurança ou um único fluxo de atualização de perfil com UI pré-construído. Simplesmente combine seu domínio com a rota para formar o URL do seu centro de contas (por exemplo, https://auth.foo.com/account/email).',
            permission_notice: 'Para integrar esses fluxos pré-construídos, defina as permissões da API de conta relacionadas como <strong>Editar</strong> nas configurações abaixo.',
            account_center_title: 'Integre o centro de contas pronto para uso',
            account_center_description: 'Direcione os usuários para o centro de contas para gerenciar configurações de segurança como e-mail, telefone, nome de usuário, senha, MFA e contas conectadas.',
            flows_title: 'Integrar fluxos de configuração de segurança prontos para uso',
            single_task_flows_title: 'Integre um fluxo de tarefa única pronto para uso',
            flows_description: 'Combine seu domínio com a rota para formar o URL de configurações da conta (por exemplo, https://auth.foo.com/account/email). Opcionalmente, adicione `redirect=` para retornar os usuários ao seu aplicativo após uma atualização bem-sucedida, `show_success=true` para manter a página de sucesso visível, `ui_locales=` para substituir o idioma padrão, ou `identifier=` para preencher previamente o campo de entrada do identificador.',
            single_task_flows_description: 'Direcione os usuários diretamente para um fluxo específico (por exemplo, vinculação de email). Opcionalmente, adicione `redirect=` para retornar os usuários ao seu aplicativo após uma atualização bem-sucedida, `show_success=true` para manter a página de sucesso visível, `ui_locales=` para substituir o idioma padrão, ou `identifier=` para preencher previamente o campo de entrada do identificador.',
            tooltips: {
                email: 'Atualize seu endereço de e-mail principal',
                phone: 'Atualize seu número de telefone principal',
                username: 'Atualize seu nome de usuário',
                password: 'Configure uma nova senha',
                social: 'Vincule uma conta social para login',
                social_change: 'Mude para outra conta social vinculada',
                social_remove: 'Remova uma conta social vinculada',
                authenticator_app: 'Configure um novo aplicativo autenticador para autenticação multifator',
                authenticator_app_replace: 'Replace your existing authenticator app with a new one',
                passkey_add: 'Registre uma nova chave de acesso',
                passkey_manage: 'Gerencie suas chaves de acesso existentes ou adicione novas',
                backup_codes_generate: 'Gere um novo conjunto de 10 códigos de backup',
                backup_codes_manage: 'Veja seus códigos de backup disponíveis ou gere novos',
                account_center: 'Acesse o centro de contas para gerenciar configurações de segurança como e-mail, telefone, nome de usuário, senha, MFA e contas conectadas',
                profile: 'O hub central para gerenciar suas informações pessoais (por exemplo, nome, avatar)',
            },
            customize_note: 'Não quer a experiência pronta para uso? Você pode totalmente',
            customize_link: 'personalizar seus fluxos com a Account API em vez disso.',
        },
        custom_css: {
            title: 'CSS personalizado',
            description: 'Personalize a aparência do centro de contas usando CSS personalizado.',
        },
    },
    sign_up_and_sign_in,
    content,
    setup_warning: {
        no_connector_sms: 'Nenhum conector SMS configurado ainda. Até terminar de configurar seu conector SMS, seus usuários não poderão fazer login. <a>{{link}}</a> em "Conectores"',
        no_connector_email: 'Nenhum conector de e-mail configurado ainda. Até terminar de configurar seu conector de e-mail, seus usuários não poderão fazer login. <a>{{link}}</a> em "Conectores"',
        no_connector_social: 'Você ainda não configurou nenhum conector social. Adicione conectores primeiro para aplicar métodos de login social. <a>{{link}}</a> em "Conectores".',
        no_connector_email_account_center: 'Nenhum conector de e-mail configurado ainda. Configure em <a>"Conectores de e-mail e SMS"</a>.',
        no_connector_sms_account_center: 'Nenhum conector SMS configurado ainda. Configure em <a>"Conectores de e-mail e SMS"</a>.',
        no_connector_social_account_center: 'Nenhum conector social configurado ainda. Configure em <a>"Conectores sociais"</a>.',
        no_mfa_factor: 'Nenhum fator de MFA configurado ainda. Configure em <a>{{link}}</a>.',
        setup_link: 'Configurar',
    },
    save_alert: {
        description: 'Você está implementando novos procedimentos de entrada e inscrição. Todos os seus usuários podem ser afetados pela nova configuração. Tem certeza de se comprometer com a mudança?',
        before: 'Antes',
        after: 'Depois',
        sign_up: 'Inscrever-se',
        sign_in: 'Entrar',
        social: 'Social',
        forgot_password_migration_notice: 'Atualizamos a verificação de senha esquecida para suportar métodos personalizados. Anteriormente, isso era determinado automaticamente pelos seus conectores de Email e SMS. Clique em <strong>Confirmar</strong> para concluir a atualização.',
    },
    preview: {
        title: 'Visualização de login',
        live_preview: 'Visualização em tempo real',
        live_preview_tip: 'Salve para visualizar as alterações',
        native: 'Nativo',
        desktop_web: 'Web Desktop',
        mobile_web: 'Web Mobile',
        desktop: 'Área de trabalho',
        mobile: 'Móvel',
    },
    custom_profile_fields,
};
export default Object.freeze(sign_in_exp);
